import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { questionnairesQueryOptions } from '@/app/(client)/questionnaires/-hooks/useQuestionnairesQuery';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/questionnaires/(pages)/(list)/my-questionnaires/archived/',
)({
  loader: () =>
    queryClient.ensureQueryData(
      questionnairesQueryOptions({
        page: 1,
        count: 50,
        isArchived: true,
      }),
    ),
  component: lazyRouteComponent(
    () =>
      import(
        '@/app/(client)/questionnaires/-components/ArchivedQuestionnairesTab'
      ),
    'ArchivedQuestionnairesTab',
  ),
});
